const ApplicationOne = ({ ordLevel }) => {
    return ( 
        <table className="mt-4">
            <thead>
                <tr>
                    <th>Month</th>
                    <th>Year</th>
                    <th>O' Level Subject</th>
                    <th>Examination Board</th>
                    <th>Results / Grade</th>
                </tr>
                </thead>
                <tbody>
                    {
                        ordLevel && ordLevel.map(subject => (
                            <tr key={subject.subject}>
                                <td>{subject.month}</td>
                                <td>{subject.year}</td>    
                                <td>{subject.subject}</td>    
                                <td>{subject.board}</td>    
                                <td>{subject.grade}</td> 
                            </tr>

                        ))
                    }           
            </tbody>
        </table>
     );
}
 
export default ApplicationOne;